// src/components/modals/ManualLocationModal.jsx
import React, { useState } from 'react';
import axios from 'axios';

export const ManualLocationModal = ({ onConfirm, onCancel }) => {
  const [city, setCity] = useState("");
  const [street, setStreet] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!city.trim()) return;
    setLoading(true);
    try {
      const address = `${street} ${city} ${postalCode}`.trim();
      const res = await axios.get(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`);
      if (res.data && res.data[0]) {
        onConfirm({
          locationName: city,
          lat: parseFloat(res.data[0].lat),
          lng: parseFloat(res.data[0].lon)
        });
      } else {
        onConfirm({ locationName: city, lat: null, lng: null });
      }
    } catch {
      onConfirm({ locationName: city, lat: null, lng: null });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[300] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-sm p-6 rounded-2xl border border-gray-200">
        <h3 className="text-sm font-bold mb-2">Dodaj lokalizację ręcznie</h3>
        <p className="text-xs text-gray-500 mb-4">Wpisz adres miejsca</p>
        
        <div className="space-y-3 mb-4">
          <input 
            type="text"
            placeholder="Miasto *"
            className="w-full bg-gray-50 p-3 rounded-xl text-sm border border-gray-200 outline-none focus:ring-2 focus:ring-blue-500"
            value={city}
            onChange={e => setCity(e.target.value)}
          />
          <input 
            type="text"
            placeholder="Ulica (opcjonalnie)"
            className="w-full bg-gray-50 p-3 rounded-xl text-sm border border-gray-200 outline-none focus:ring-2 focus:ring-blue-500"
            value={street}
            onChange={e => setStreet(e.target.value)}
          />
          <input 
            type="text"
            placeholder="Kod pocztowy (opcjonalnie)"
            className="w-full bg-gray-50 p-3 rounded-xl text-sm border border-gray-200 outline-none focus:ring-2 focus:ring-blue-500"
            value={postalCode}
            onChange={e => setPostalCode(e.target.value)}
          />
        </div>

        <div className="flex gap-2">
          <button onClick={onCancel} className="flex-1 py-3 text-xs font-semibold text-gray-500 hover:bg-gray-100 rounded-lg transition-colors">
            Anuluj
          </button>
          <button 
            onClick={handleSubmit} 
            disabled={!city.trim() || loading}
            className="flex-1 py-3 bg-blue-600 text-white rounded-lg text-xs font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50"
          >
            {loading ? "Szukam..." : "Zatwierdź"}
          </button>
        </div>
      </div>
    </div>
  );
};